import {LivenessContent} from 'components/SmartKYC';

export const Liveness = () => <LivenessContent />;
